module.exports = __webpack_public_path__ + "img/shopee_web.e444f0e4.png";